module.exports = __webpack_public_path__ + "img/cup_icon.06acb2a6.png";